export default __webpack_public_path__ + "static/media/jump_run_thumb.de3c1cae.png";